import React from 'react'
import { Helmet } from 'react-helmet';
import Translate from '../Translate/Translate';
import {useTranslate} from '../Translate/Translate' 

const MetaTags = ({title,description}) => {
  return (
    <Helmet>
        <meta name="og:url" content={window.location.href} />
        <meta name="og:site_name" content="Open Data Tel-Aviv" />
        <meta name="og:type" content="website" />
        <meta name="og:title" content={`${useTranslate("TelAvivMuni")} - ${title}` } />
        {/* <meta name="og:app_id" content="" /> */}
        <meta name="og:description" content={description} />
        <meta name="og:image" content="https://www.tel-aviv.gov.il/Lists/designGalleryList/facebook.jpg?RenditionID=18" />       
        <meta name="description" content={description} />
        {/* <meta name="keywords" content="" /> */}
        <title>{`${useTranslate("TelAvivMuni")} - ${title}` } </title>
      </Helmet>
  )
}

export default MetaTags